import { push } from 'react-router-redux';
import * as actionTypes from './actionTypes';
import { JWTOKEN, STAFFID, STDBIDSESSION_ID, CATEGORY_ID } from './../constants';
let commonLabels;
if (sessionStorage.getItem('lng') === 'fr') {
  commonLabels = require('./../../labels/labels.french.json').commonLabels;
} else {
  commonLabels = require('./../../labels/labels.json').commonLabels;
}

export const fetchLoginFailure = message => ({
  type: actionTypes.FETCH_LOGIN_FAILURE,
  message
});
export const fetchLoginSuccess = login => ({
  type: actionTypes.FETCH_LOGIN_SUCCESS,
  login
});

export const userLogout = () => ({ type: actionTypes.USER_LOGOUT });

export const fetchLogin = (staffId = 'Admin', password = '') => {
  return dispatch => {
    fetch('/api/auth/login', {
      method: 'POST',
      body: JSON.stringify({
        staffId: staffId,
        password: password
      })
    })
      .then(response => response.json())
      .then(json => {
        const { token, user } = json;

        const access_token = JSON.stringify({ token });

        sessionStorage.setItem(JWTOKEN, access_token);
        sessionStorage.setItem(STAFFID, user.staffId);

        sessionStorage.setItem(STDBIDSESSION_ID, user.standingBidSessionId || null);
        sessionStorage.setItem(CATEGORY_ID, '');
        dispatch(push('home'));
        return dispatch(fetchLoginSuccess({ access_token, user }));
      });
  };
};

export const fetchLoginSSO = () => {
  return dispatch => {
    fetch('/api/auth/login', {
      method: 'POST',
      body: JSON.stringify({
        staffId: 'Admin',
        password: ''
      })
    })
      .then(response => response.json())
      .then(json => {
        const { token, user } = json;

        const access_token = JSON.stringify({ token });

        sessionStorage.setItem(JWTOKEN, access_token);
        sessionStorage.setItem(STAFFID, user.staffId);

        sessionStorage.setItem(SBSID, user.standingBidSessionId || null);
        sessionStorage.setItem(CATEGORY_ID, '');
        dispatch(push('home'));
        return dispatch(fetchLoginSuccess({ access_token, user }));
      });
  };
};


export function getUserInformation(staffId) {
  return () => {
    const userRequestUrl = `employees/${staffId}`;
    return fetch(`/api/${userRequestUrl}`, {
      method: 'GET'
    })
      .then(res => res.json())
      .then(json => {
        return json;
      });
  };
}

export function redirect(path) {
  return dispatch => {
    dispatch(push(path));
  };
}

export function logout(path) {
  return dispatch => {
    // Preserve language preference
    const tempLng = localStorage.getItem('lng') || sessionStorage.getItem('lng');
    dispatch(push(path));
    dispatch(userLogout());
    sessionStorage.clear();
    // Restore language preference
    if (tempLng) {
      localStorage.setItem('lng', tempLng);
      sessionStorage.setItem('lng', tempLng);
    }
  };
}

export function expireSession() {
  return dispatch => {
    // Preserve language preference
    const tempLng = localStorage.getItem('lng') || sessionStorage.getItem('lng');
    dispatch(push('session-expired'));
    dispatch(userLogout());
    sessionStorage.clear();
    // Restore language preference
    if (tempLng) {
      localStorage.setItem('lng', tempLng);
      sessionStorage.setItem('lng', tempLng);
    }
  };
}
